import React, { useState, useEffect, useContext } from "react";
import TrendingDownRoundedIcon from "@mui/icons-material/TrendingDownRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getMoraTotalAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const money = (n) => new Intl.NumberFormat("es-NI", { style: "currency", currency: "NIO" }).format(n);

const MoraTotal = ({ selectedSucursal }) => {
  const [mora, setMora] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getMoraTotalAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setMora(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/credits`)}
      icon={<TrendingDownRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="warning.light"
      iconColor="warning.main"
      value={money(mora)}
      label="Mora total"
    />
  );
};

export default MoraTotal;
